import styled from 'styled-components';

export const MainMenu = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: center;
  column-gap: 25px;

  & > li {
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    cursor: pointer;
  }
  & > .about {
    display: none;
    @media screen and (orientation: portrait) {
      display: block;
    }
  }
  @media screen and (orientation: portrait) {
    flex-direction: column;
    row-gap: 10px;
  }
`;

export const MainMenuStory = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: center;
  column-gap: 25px;

  & > li {
    color: #000;
    font-size: 12px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0.84px;
    text-transform: uppercase;
    cursor: pointer;
  }
  @media screen and (orientation: portrait) {
    column-gap: 15px;
  }
`;

export const MainMenuBaileys = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: center;
  column-gap: 25px;

  & > li {
    color: #000;
    font-size: 12px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0.84px;
    text-transform: uppercase;
    cursor: pointer;
  }
  @media screen and (orientation: portrait) {
    column-gap: 15px;
  }
`;
